import { render, staticRenderFns } from "./ResumeSection.vue?vue&type=template&id=45424d72&"
import script from "./ResumeSection.vue?vue&type=script&lang=js&"
export * from "./ResumeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports